import React from 'react';
import { useNavigate } from 'react-router-dom';
import { formatDateTime } from '../../utils/format';

// A unit's roster: name, email and last login. Rows with an id (a Kabilah
// account in the organization) open that nurse's page. With onRemove, each of
// those rows also gets an × to take the nurse off the unit.
const NurseTable = ({ nurses, emptyText, onRemove, removingId }) => {
  const navigate = useNavigate();
  return (
    <div className="data-table" aria-label="Nurses">
      <div className="data-table-header">
        <span className="col-name">Name</span>
        <span className="col-email">Email</span>
        <span className="col-login">Last Login</span>
        <span className="col-actions" />
      </div>
      {nurses.length === 0 && (
        <div className="data-row"><span className="muted">{emptyText}</span></div>
      )}
      {nurses.map((nurse) => {
        const name = nurse.name || nurse.email;
        const open = nurse.id ? () => navigate(`/nurses/${encodeURIComponent(nurse.id)}`) : undefined;
        return (
          <div
            key={nurse.id || nurse.email}
            className={`data-row${open ? ' data-row-clickable' : ''}`}
            {...(open && {
              role: 'link',
              tabIndex: 0,
              onClick: open,
              onKeyDown: (e) => { if (e.key === 'Enter' && e.target === e.currentTarget) open(); },
            })}
          >
            <div className="col-name">
              <span className="avatar" aria-hidden="true">{(name || '?').charAt(0).toUpperCase()}</span>
              <span className="person-name">{name}</span>
            </div>
            <span className="col-email">{nurse.email}</span>
            <span className="col-login">
              {!nurse.id ? <span className="muted">No Aren account</span>
                : (nurse.hasLoggedIn && formatDateTime(nurse.lastLoginAt)) || <span className="muted">Never logged in</span>}
            </span>
            <span className="col-actions">
              {onRemove && nurse.id && (
                <button
                  type="button"
                  className="remove-button"
                  onClick={(e) => { e.stopPropagation(); onRemove(nurse); }}
                  disabled={removingId === nurse.id}
                  title="Remove from unit"
                  aria-label={`Remove ${name} from this unit`}
                >
                  ×
                </button>
              )}
            </span>
          </div>
        );
      })}
    </div>
  );
};

export default NurseTable;
